/* eslint-disable dot-notation */
import { getToken } from 'data/auth/utils'
import { OrganizationNotFoundError } from 'scenes/Dashboard/data/organizations/errors'
import { DuplicatedPairingError } from 'scenes/Dashboard/data/pairings/errors'
import { BasicPairing, CreateBasicPairing } from 'scenes/Dashboard/data/pairings/types'
import { ScoutingCampaignNotFoundError } from 'scenes/Dashboard/data/scouting-campaigns/errors'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { extractDomainError } from 'services/api'

const PAIRING_ENDPOINT_PATH = 'admin/pairings/'

export function getApiPairingsHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const { callApiRaw } = createApiHandler(token, config)

  async function apiCreateNewPairing(basicPairingInformation: CreateBasicPairing) {
    try {
      const response = await callApiRaw({
        url: PAIRING_ENDPOINT_PATH,
        method: 'post',
        data: basicPairingInformation,
      })

      return response.data as BasicPairing
    } catch (error: unknown) {
      const domainError = extractDomainError(error)

      switch (domainError?.domain) {
        case 'ScoutingCampaignNotFoundError':
          throw new ScoutingCampaignNotFoundError(domainError.message)
        case 'OrganizationNotFoundError':
          throw new OrganizationNotFoundError(domainError.message)
        case 'DuplicatedPairingError':
          throw new DuplicatedPairingError(domainError.message)
        default:
          throw error
      }
    }
  }

  return {
    apiCreateNewPairing,
  }
}
